import { css } from 'styled-components';
import { forDesktop } from '@westwing/ui-kit/breakPoints';

export interface LayoutOptions {
    mobileOnly?: boolean;
    desktopOnly?: boolean;
}

function getLayoutValues(layoutStyles?: string, defaultStyles?: string) {
    return ({ mobileOnly = false, desktopOnly = false }: LayoutOptions) => {
        if (mobileOnly) {
            return css`
                ${layoutStyles}

                ${forDesktop`
                    ${defaultStyles}
                `}
            `;
        }
        if (desktopOnly) {
            return css`
                ${forDesktop`
                    ${layoutStyles}
                `}
            `;
        }
        return css`
            ${layoutStyles}
        `;
    };
}

export default getLayoutValues;
